import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Button, TextInput } from '@demandlocal/components'

export default function OnboardingStepThree({
  onBackPress,
}: {
  onBackPress: () => void
}): JSX.Element {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext()

  return (
    <div className="w-full">
      {/* Header */}
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-800">
          Let's Get Your Dealership Rolling!
        </h2>
        <p className="mt-2 text-lg text-gray-600">
          Provide some details about your dealership to help us set things up.
        </p>
      </div>

      {/* Form Fields */}
      <div className="mb-10 space-y-6">
        {/* Dealership Name (required) */}
        <div>
          <TextInput
            inverted
            name="dealership_name"
            label="Dealership Name"
            control={control}
            rules={{ required: 'Dealership name is required' }}
          />
        </div>

        {/* Optional fields in a responsive grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <TextInput
              inverted
              name="address"
              label="Address"
              control={control}
              rules={{}}
            />
          </div>
          <div>
            <TextInput inverted name="city" label="City" control={control} rules={{}} />
          </div>
          <div>
            <TextInput inverted name="state" label="State" control={control} rules={{}} />
          </div>
          <div>
            <TextInput
              inverted
              name="zip"
              label="ZIP Code"
              control={control}
              rules={{}}
            />
          </div>
          <div className="md:col-span-2">
            <TextInput
              inverted
              name="url"
              label="Website URL"
              control={control}
              rules={{
                pattern: {
                  value: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
                  message: 'Enter a valid URL',
                },
              }}
            />
          </div>
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-between">
        <Button
          variant="secondary"
          type="button"
          animate={false}
          onClick={onBackPress}
          disabled={isSubmitting}>
          Back
        </Button>
        <Button type="submit" animate={false} disabled={isSubmitting}>
          Save
        </Button>
      </div>
    </div>
  )
}
